<div class="cc-card w-100">
	<div class="flex row start center w-100 g-8">
		@if (selectable) {
			<mat-radio-button #radioButton [checked]="selected" (change)="selectPaymentMethod()"></mat-radio-button>
		}
		<div class="flex row start center w-100 g-16" [ngClass]="{ 'pointer': selectable }" (click)="setRadioButtonValue(true)">
			<app-credit-card-type class="mt-6" [type]="paymentMethod?.__cardTypeEnum"></app-credit-card-type>
			<div class="flex column start center">
				<p class="body1">•••• •••• •••• {{ paymentMethod?.lastFour }}</p>
				<p class="body3">{{ 'account.expiration_card' | translateWithKeys:{ params: { date: paymentMethod?.expirationDate } } }}</p>
			</div>
		</div>
	</div>
	@if (allowDelete) {
		@if (deleting) {
			<mat-spinner [diameter]="20" color="warn"></mat-spinner>
		} @else {
			<mat-icon class="icon-size pointer" svgIcon="delete" (click)="openDeleteConfirmationDialog(paymentMethod?.id)"></mat-icon>
		}
	}
</div>
